import React from 'react';
import ThemesScroll from '../ThemesScroll';
import Layout from '../../../components/Layout';
import HeadMessage from '../../../components/Common/HeadMessage/HeadMessage';

/**
 * Все темы
 * @param fetch
 * @returns {Promise<{component: *, chunks: string[], title: string}>}
 */
async function action({ fetch }) {
	const getLoadQuery = (page = 1) => {
		return `{themes(status:"ALL", page:${page}, order: "createdAt DESC"){id,title,description,installs,workspace}}`;
	};

	const resp = await fetch('/graphql', {
		body: JSON.stringify({
			query: getLoadQuery(),
		}),
	});

	const { data } = await resp.json();
	// if (!data || !data.themes) throw new Error('Failed to load themes.');

	return {
		title: 'All themes',
		chunks: ['all-themes'],
		component: (
			<Layout>
				<HeadMessage>
					<h1>
						All <span>themes</span>
					</h1>
				</HeadMessage>

				<ThemesScroll
					key="allthemes-list"
					getLoadQuery={getLoadQuery}
					title="All themes"
					themes={data.themes}
					fetch={fetch}
				/>
			</Layout>
		),
	};
}

export default action;
